'use client'

import React from 'react'
import { LinkProps } from 'next/link'
import { useCookieState } from '@dustin-web/microsite-components/src/hooks/use-cookie-state'
import useNotifyClick from '@dustin-web/product-components/src/hooks/dataloader/use-notify-click'
type Props =
  | React.PropsWithChildren<{
      url: string
      ticket: string
      onClickCallBack?: () => void
      className?: React.HTMLProps<HTMLElement>['className']
      useAnchorTag?: boolean
    }> &
      Omit<LinkProps, 'href'> & { [key: string]: string | object | boolean }

export const TicketLink = ({
  url,
  ticket,
  onClickCallBack,
  useAnchorTag = false,
  children,
  ...props
}: Props) => {
  const { cookies } = useCookieState()
  const notifyClick = useNotifyClick()
  const onClick = () => {
    if (onClickCallBack) {
      onClickCallBack()
    }
    if (ticket && cookies.consent.personalization === 'true') {
      notifyClick({
        variables: {
          ticket,
        },
      })
    }
  }

  return (
    <a href={url} onClick={onClick} {...props}>
      {children}
    </a>
  )
}
